import {EventEmitter} from 'eventemitter3'

export const tableRowSelectionEvent = new EventEmitter()

export const tableRowSelectionEventTypes = {
    ROW_SELECTION_CHANGE: 'ROW_SELECTION_CHANGE',
}

export function getTableRowSelectionEventKey(tableType, eventType) {
    if (!tableType) {
        return ''
    }

    switch (eventType) {
        case tableRowSelectionEventTypes.ROW_SELECTION_CHANGE:
            return `ROW_SELECTION_CHANGE_${tableType}`

        default:
            return ''
    }
}

export function onTableRowSelectionChangeListener(
    tableType,
    eventType = tableRowSelectionEventTypes.ROW_SELECTION_CHANGE,
    newTableRowSelection = [],
) {
    if (!tableType) {
        return
    }

    if (
        newTableRowSelection?.length > 0 &&
        newTableRowSelection?.some(row => row?.emptyRow)
    ) {
        const filterRemoveEmptyRowSelection = newTableRowSelection.filter(
            row => !row?.emptyRow,
        )

        tableRowSelectionEvent.emit(
            `${getTableRowSelectionEventKey(tableType, eventType)}`,
            filterRemoveEmptyRowSelection,
        )
    } else {
        tableRowSelectionEvent.emit(
            `${getTableRowSelectionEventKey(tableType, eventType)}`,
            newTableRowSelection,
        )
    }
}

export function removeTableRowSelectionChangeListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    tableRowSelectionEvent.removeListener(
        `${getTableRowSelectionEventKey(tableType, eventType)}`,
    )
}
